import React, { useEffect } from 'react';
import { useHookstate } from '@hookstate/core';
import CrudIndex from '~/components/CrudIndex';
import Layout from '~/components/Layout';
import { useLang } from '~/hooks/useLang';


export default function Index() { 
  const { translate } = useLang();

  const name = useHookstate<string | null>(null)
  const ibgeCode = useHookstate<string | null>(null)
  const forceRefresh = useHookstate(false)

  useEffect(() => {
    document.title = translate('Administration - Dispatch System')
  }, [])       

  const cityFilter = [
    {
      name: 'name',
      type: 'name',
      placeholder: translate('Name'),
      variable: name,
    },
    {
      name: 'ibge_code',
      type: 'name',
      placeholder: translate('Ibge Code'),
      variable: ibgeCode,
    },
  ]

  return(
    <Layout marginLayout={true}>
      <CrudIndex 
        model='city' 
        title='Cities'
        disableColumnsFilters
        forceShowColumns={['id']}
        viewTitle="city"
        canView={true}
        showInViewMore={['name', 'state:name', 'created_at']}
        forceOrderColumns={['name', 'state:name']}
        notSortable={['state:name']}
        searchButton={() => forceRefresh.set(!forceRefresh.get())}
        forceRefresh={forceRefresh.get()}
        filters={cityFilter}
        clearFilters={() => {
          name.set('')
          ibgeCode.set('')
           forceRefresh.set(!forceRefresh.get())
         }}
         aliasLabel={[
           {column: 'id', label: 'Ibge Code'},
           {column: 'state:name', label: 'State'}
         ]}
       />
    </Layout>
  )
}